import { render, staticRenderFns } from "./workspace-setting-payment.vue?vue&type=template&id=00d8d453&"
import script from "./workspace-setting-payment.vue?vue&type=script&lang=js&"
export * from "./workspace-setting-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports